import first from "lodash/first";
import last from "lodash/last";
import { RowsWithRefs } from "PFApp/booking/store";
import { Row } from "PFApp/booking/types";

type GetMaxVerticalTop = {
  rowsWithRefs: RowsWithRefs<Row>;
  initialClientPositionY: number;
};

type GetMaxVerticalTopReturn = {
  maxTopUp: number;
  maxTopDown: number;
};

export const getMaxVerticalTop = ({
  rowsWithRefs,
  initialClientPositionY
}: GetMaxVerticalTop): GetMaxVerticalTopReturn => {
  const rows = Array.from(rowsWithRefs.values());
  const firstRowRect = first(rows)?.rowRef?.getBoundingClientRect();
  const lastRowRect = last(rows)?.rowRef?.getBoundingClientRect();

  return {
    maxTopUp: (firstRowRect?.y ?? 0) - initialClientPositionY,
    maxTopDown: (lastRowRect?.bottom ?? 0) - initialClientPositionY
  };
};
